<template>
  <div class="container">
    <div class="result-information-button" :class="{'widthLimit': isUSTWall || isSimple}">
      <el-button  v-if="!isUSTWall && !isSimple"
        type="button"
        class="copy"
        id="copy"
        @click="copy"
        data-clipboard-target="#copy_text"
      >{{$t('T_RESULT_COPY_TO_CLIPBOARD')}}</el-button>
       <!-- シンプルモード 型番検索 PDF出力 (サイズ優先)-->
      <el-button type="button" class="pdf" id="pdf" @click='SimpleOpenCancelAction("size")' v-if="isSimple">{{$t('T_RESULT_OUTPUT_AS_PDF_FILE_MIN_SIZE')}}</el-button>
      <!-- シンプルモード 型番検索 PDF出力 (画質優先)-->
      <el-button type="button" class="pdf" id="pdf" @click='SimpleOpenCancelAction("quality")' v-if="isSimple">{{$t('T_RESULT_OUTPUT_AS_PDF_FILE_STANDARD')}}</el-button>
      <div v-else class="pdfBtnDiv">
        <!--アドバンストモード 型番検索 PDF出力 (サイズ優先) -->
        <el-button type="button" id="pdf" class="pdf pdfBtnM_S" @click='openCancelAction("size")' >{{$t('T_RESULT_OUTPUT_AS_PDF_FILE_MIN_SIZE')}}</el-button>
         <!--アドバンストモード 型番検索 PDF出力 (画質優先) -->
         <el-button type="button" id="pdf" class="pdf pdfBtnM_Q" @click='openCancelAction("quality")' >{{$t('T_RESULT_OUTPUT_AS_PDF_FILE_STANDARD')}}</el-button>
      </div>
      <!-- <span class="simple-pdf-title" v-if="isSimple">{{$t('T_SIMPLEUI_OUTPUT_AS_PDF_FILE')}}</span> -->
    </div>
    <el-dialog id='resultReport-dialog' :visible.sync="dialogVisible" width="1280px" :close-on-click-modal=false @opened='initReport'>
      <resultReport ref="resultReport" :isCurvedTab="isCurvedTab" :reportTopTableInfo="reportTopTableInfo" :projectorPosition="projectorPosition" :projectorSetting="projectorSetting" :floor2footProjectorIsNegativeNum='floor2footProjectorIsNegativeNum'></resultReport>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click='openCancelAction'>{{$t('T_CANCEL')}}</el-button>
        <el-button type="primary" @click='saveAsPdf'>{{$t('T_SAVE_PDF')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
import resultReport from '@/view/result/resultReport'
import html2canvas from 'html2canvas'
import JsPDF from 'jspdf'
import { mapState, mapGetters, mapMutations } from 'vuex'
import { gaEvent } from '../../common/ga'// GA追加
import { EventBus } from '@/common/event-bus.js' // GA追加
import domtoimage from 'dom-to-image'
export default {
  name: 'resultInformationButton',
  data () {
    return {
      dialogVisible: false,
      reportTopTableInfo: [],
      projectorPosition: [],
      projectorSetting: [],
      relativeBasePointer: '',
      UstResultImg: '',
      SimpleResultImg: '',
      floor2footProjectorIsNegativeNum: false,
      definition: 0.69
    }
  },
  methods: {
    ...mapMutations([
      'SET_SHOWINPUTFLAG', 'SET_TEXTDATA', 'SET_KEYSTONEVERTICAL', 'SET_KEYSTONEHORIZONTAL', 'SET_SETTINGACTIVE', 'SET_FONTSIZE', 'SET_DISABLEDNONE', 'SET_THROWACTIVE', 'SET_SCREENSIZEACTIVE'
    ]),
    // 复制
    copy () {
      var clipboard = new Clipboard('.copy')
      clipboard.on('success', e => {
        // alert('复制成功')
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // 不支持复制
        alert('该浏览器不支持自动复制')
        // 释放内存
        clipboard.destroy()
      })
    },

    saveAsPdf () {
      this.SET_SHOWINPUTFLAG(false)
      setTimeout(() => {
        this.saveAsPdfAction()
      }, 0)
    },

    saveAsPdfAction () {
      // 手动创建一个 canvas 标签
      const canvas = document.createElement('canvas')
      // 获取父标签，意思是这个标签内的 DOM 元素生成图片
      let canvasBox = document.getElementById('resultReport')
      // 获取父级的宽高
      const width = parseInt(window.getComputedStyle(canvasBox).width)
      const height = parseInt(window.getComputedStyle(canvasBox).height)
      // 宽高 * 2 并放大 2 倍 是为了防止图片模糊
      canvas.width = width * this.definition
      canvas.height = height * this.definition
      canvas.style.width = width + 'px'
      canvas.style.height = height + 'px'
      const context = canvas.getContext('2d')
      let ratio = this.detectZoom()
      context.scale(this.definition * ratio, this.definition * ratio)
      const options = {
        // backgroundColor: null,
        canvas: canvas,
        useCORS: true,
        y: 0,
        x: 0,
        scrollX: document.getElementById('resultReport-dialog').scrollLeft - (document.getElementById('resultReport-dialog').children[0].offsetLeft + document.getElementById('resultReport').offsetLeft),
        scrollY: document.getElementById('resultReport-dialog').scrollTop - (document.getElementById('resultReport-dialog').children[0].offsetTop + document.getElementById('resultReport').offsetTop),
        windowHeight: window.innerHeight,
        windowWidth: window.innerWidth
      }
      html2canvas(canvasBox, options).then((canvas) => {
        // toDataURL 图片格式转成 base64
        let imgData = canvas.toDataURL('image/jpeg', 1.0)
        var img = new Image()
        img.src = imgData
        var imgWidth = 595.28
        var imgHeight = 592.28 / (canvas.width * 0.5) * (canvas.height * 0.5)
        img.onload = () => {
          var doc = new JsPDF('', 'pt', 'a4')
          doc.addImage(imgData, 'jpeg', 0, 0, imgWidth, imgHeight)
          doc.save('pdf_' + new Date().getTime() + '.pdf')
          this.SET_SHOWINPUTFLAG(true)
        }
      })
    },

    // 获取当前页面的缩放值
    detectZoom () {
      let ratio = 0
      let screen = window.screen
      let ua = navigator.userAgent.toLowerCase()

      if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio
      } else if (~ua.indexOf('msie')) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
          ratio = screen.deviceXDPI / screen.logicalXDPI
        }
      } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
        ratio = window.outerWidth / window.innerWidth
      }

      if (ratio) {
        ratio = Math.round(ratio * 100)
      }
      return (100 / ratio).toFixed(2) * 1
    },

    SimpleOpenCancelAction (type) {
      if (this.screenActive.length > 0) {
        this.SET_SCREENSIZEACTIVE([])
      }
      if (this.throwDisActive.length > 0) {
        this.SET_THROWACTIVE([])
      }
      this.SET_DISABLEDNONE(true)
      this.SET_FONTSIZE(true)
      this.$nextTick(() => {
        this.openCancelAction(type)
      })
    },

    openCancelAction (type) {
      // GA追加Start
      if (type === 'size' || type === 'quality') {
        EventBus.$emit('sendToGA', 'view_item', type)
      }
      // GA追加End
      // GA追加：对按钮「PDF（標準）」和「PDF（最小サイズ）」的监听
      let actionNm = ''
      if (type === 'quality') {
        actionNm = 'PDF (Standard)' // 国际化对应备份：this.$t('T_RESULT_OUTPUT_AS_PDF_FILE_STANDARD')
      }
      if (type === 'size') {
        actionNm = 'PDF (Minimum size)' // 国际化对应备份：this.$t('T_RESULT_OUTPUT_AS_PDF_FILE_MIN_SIZE')
      }
      gaEvent({action: actionNm})
      // GA追加：对按钮「PDF（標準）」和「PDF（最小サイズ）」的监听
      if (type === 'quality') {
        this.definition = 4
      } else {
        this.definition = 0.69
      }
      this.SET_FONTSIZE(false)
      this.SET_TEXTDATA('')
      let infoItem = document.getElementsByClassName('info-item')
      let informationL = document.getElementsByClassName('information-left')
      if (!this.dialogVisible) {
        this.formatReportTopTableInfo()
        this.formatReportInfo()
      }
      if (!this.dialogVisible && this.isUSTWall) {
        var targetDom = document.getElementById('USTView')
        let value = document.documentElement.scrollTop ? document.documentElement.scrollTop : document.body.scrollTop
        html2canvas(targetDom, {
          allowTaint: false,
          useCORS: true,
          windowWidth: document.body.scrollWidth,
          windowHeight: document.body.scrollHeight,
          dpi: window.devicePixelRatio * 2,
          scale: 2,
          scrollY: value * (-1)
        }).then(canvas => {
          let imgData = canvas.toDataURL('image/jpeg', 1.0)
          this.UstResultImg = new Image(800, 664)
          this.UstResultImg.src = imgData
          this.UstResultImg.id = 'ustImg'
          this.dialogVisible = true
        })
      } else if (!this.dialogVisible && this.isSimple) {
        var simpleDom = document.getElementById('SimpleView')
        domtoimage.toPng(simpleDom, {
          width: 1276
        }).then((dataUrl) => {
          this.SimpleResultImg = new Image(998, 668)
          this.SimpleResultImg.src = dataUrl
          this.SimpleResultImg.id = 'simpleImg'
          this.dialogVisible = true
          this.SET_DISABLEDNONE(false)
        }).catch(function (error) {
          console.error('oops, something went wrong!', error)
        })
      } else {
        this.dialogVisible = !this.dialogVisible
      }
      setTimeout(() => {
        if (this.isUSTWall) {
          if (infoItem[0].offsetHeight > 206) {
            infoItem[0].style.width = '65%'
            infoItem[1].style.width = '35%'
          } else {
            infoItem[0].style.width = '50%'
            infoItem[1].style.width = '50%'
          }
        } else if (this.isSimple) {
          return ''
        } else {
          if (informationL[0].scrollHeight > informationL[0].clientHeight || informationL[0].offsetHeight > informationL[0].clientHeight) {
            infoItem[0].style.width = '65%'
            infoItem[1].style.width = '35%'
          } else {
            infoItem[0].style.width = '50%'
            infoItem[1].style.width = '50%'
          }
        }
      }, 500)
    },

    formatReportTopTableInfo () {
      this.reportTopTableInfo = []
      let tempObj = this.$store.state.selectedModelData
      let tempLens = this.$store.state.selectedLensData
      // PDF出力時の情報にOPレンズ利用時の減光された明るさ表示
      if (this.selectedModelData.lensExchange === true) {
        this.reportTopTableInfo.push({
          title: 'T_INFO_BRIGHTNESS',
          value: this.$commonViewJs.getBrightnessByLens()
        })
      } else {
        this.reportTopTableInfo.push({
          title: 'T_INFO_BRIGHTNESS',
          value: tempObj.color
        })
      }
      this.reportTopTableInfo.push({
        title: 'T_INFO_RESOLUTION',
        value: tempObj.resolution
      })
      this.reportTopTableInfo.push({
        title: 'T_INFO_WEIGHT',
        value: tempObj.weightIncludingLens.substring(tempObj.weightIncludingLens.indexOf('/') + 1, tempObj.weightIncludingLens.length).trim()
      })
      if (this.selectedModelData.lensExchange === true) {
        this.reportTopTableInfo.push({
          title: 'T_LENS_NAME',
          value: tempLens.name.substring(0, tempLens.name.indexOf('(') - 1) + ' ' + '(' + tempLens.name.substring(tempLens.name.indexOf(')') + 1, tempLens.name.length).trim() + ')'
        })
      } else {
        this.reportTopTableInfo.push({
          title: 'T_LENS_NAME',
          value: '-'
        })
      }
      if (this.selectedModelData.lensExchange === true) {
        this.reportTopTableInfo.push({
          title: 'T_THROW_RATIO',
          value: tempLens.throwRatio
        })
      } else {
        this.reportTopTableInfo.push({
          title: 'T_THROW_RATIO',
          value: '-'
        })
      }
      this.reportTopTableInfo.push({
        title: 'T_INFO_POWER_CONSUMPTION',
        value: tempObj.consumption220 + '/' + tempObj.consumption220_eco
      })
    },

    formatReportInfo () {
      this.projectorPosition = []
      this.projectorSetting = []
      if (!this.isCurvedTab) {
        if (this.position === 0) {
          if ((this.vAngleFlag && this.vAngle !== 0) || (this.hAngleFlag && this.hAngle !== 0)) {
            this.projectorPosition.push({
              title: 'T_RESULT_FLOOR_TO_FOOT_OF_PROJECTOR_HEIGHT',
              value: this.floor2Projector + ' ' + this.unitLableText
            }, {
              title: 'T_RESULT_SCREEN_TO_LENS_DISTANCE',
              value: this.pjYData + ' ' + this.unitLableText
            }, {
              title: 'T_RESULTCEILING_TO_TOP_HEIGHT',
              value: this.screenTopToCeiling
            }, {
              title: 'T_RESULT_FLOOR_TO_BOTTOM',
              value: this.floor2bottomCpmuted
            }, {
              title: 'T_RESULT_WIDE_X_HEIGHT_SCREEN_SIZE',
              value: this.scrnW_H
            }, {
              title: 'T_RESULT_DIAGONAL_INCH_SCREEN_SIZE',
              value: this.screenSizeComputed
            }, {
              title: 'T_RESULT_PROJECTOR_ANGLE_V',
              value: this.vAngleData
            }, {
              title: 'T_RESULT_PROJECTOR_ANGLE_R_KEYSTONE',
              value: this.hAngleData
            })
          } else if (this.$store.state.selectedModelData.lensExchange && this.selectedLensData.id.indexOf('LX') > -1) {
            this.projectorPosition.push({
              title: 'T_RESULT_FLOOR_TO_FOOT_OF_PROJECTOR_HEIGHT',
              value: this.floor2footProjector,
              isNegativeNum: this.floor2footProjectorIsNegativeNum
            }, {
              title: 'T_RESULT_BOTTOM_OF_SCREEN_TO_FOOT_OF_PROJECTOR_HEIGHT',
              value: this.bottom2FootProjector
            }, {
              title: 'T_RESULT_SCREEN_TO_LENS_DISTANCE',
              value: this.pjYData + ' ' + this.unitLableText
            }, {
              title: 'T_RESULT_SCREEN_TO_PROJECTOR',
              value: this.screen2projector
            }, {
              title: 'T_RESULTCEILING_TO_TOP_HEIGHT',
              value: this.screenTopToCeiling
            }, {
              title: 'T_RESULT_FLOOR_TO_BOTTOM',
              value: this.floor2bottomCpmuted
            }, {
              title: 'T_RESULT_WIDE_X_HEIGHT_SCREEN_SIZE',
              value: this.scrnW_H
            }, {
              title: 'T_RESULT_DIAGONAL_INCH_SCREEN_SIZE',
              value: this.screenSizeComputed
            })
          } else {
            this.projectorPosition.push({
              title: 'T_RESULT_FLOOR_TO_FOOT_OF_PROJECTOR_HEIGHT',
              value: this.floor2footProjector,
              isNegativeNum: this.floor2footProjectorIsNegativeNum
            }, {
              title: 'T_RESULT_BOTTOM_OF_SCREEN_TO_FOOT_OF_PROJECTOR_HEIGHT',
              value: this.bottom2FootProjector
            }, {
              title: 'T_RESULT_SCREEN_TO_LENS_DISTANCE',
              value: this.pjYData + ' ' + this.unitLableText
            }, {
              title: 'T_RESULTCEILING_TO_TOP_HEIGHT',
              value: this.screenTopToCeiling
            }, {
              title: 'T_RESULT_FLOOR_TO_BOTTOM',
              value: this.floor2bottomCpmuted
            }, {
              title: 'T_RESULT_WIDE_X_HEIGHT_SCREEN_SIZE',
              value: this.scrnW_H
            }, {
              title: 'T_RESULT_DIAGONAL_INCH_SCREEN_SIZE',
              value: this.screenSizeComputed
            })

            if (this.selectedModelData.category === 4) {
              const newItem = {
                title: 'T_RESULT_SCREEN_TO_FRONT_OF_PROJECTOR',
                value: this.screenToFrontOfProjector + ' ' + this.unitLableText
              }
              this.projectorPosition.splice(3, 0, newItem)
            }
          }
        } else {
          if ((this.vAngleFlag && this.vAngle !== 0) || (this.hAngleFlag && this.hAngle !== 0)) {
            this.projectorPosition.push({
              title: 'T_RESULT_CEILING_TO_LENS',
              value: this.floor2Projector + ' ' + this.unitLableText
            }, {
              title: 'T_RESULT_SCREEN_TO_LENS_DISTANCE',
              value: this.pjYData + ' ' + this.unitLableText
            }, {
              title: 'T_RESULTCEILING_TO_TOP_HEIGHT',
              value: this.screenTopToCeiling
            }, {
              title: 'T_RESULT_FLOOR_TO_BOTTOM',
              value: this.floor2bottomCpmuted
            }, {
              title: 'T_RESULT_WIDE_X_HEIGHT_SCREEN_SIZE',
              value: this.scrnW_H
            }, {
              title: 'T_RESULT_DIAGONAL_INCH_SCREEN_SIZE',
              value: this.screenSizeComputed
            }, {
              title: 'T_RESULT_PROJECTOR_ANGLE_V_KEYSTONE',
              value: this.vAngleData
            }, {
              title: 'T_RESULT_PROJECTOR_ANGLE_R_KEYSTONE',
              value: this.hAngleData
            })
          } else if (this.$store.state.selectedModelData.lensExchange && this.selectedLensData.id.indexOf('LX') > -1) {
            this.projectorPosition.push({
              title: 'T_RESULT_CEILING_TO_BOTTOM_HEIGHT',
              value: this.ceiling2topLx
            }, {
              title: 'T_RESULT_SCREEN_TO_BOTTOM_HEIGHT',
              value: this.top2bottomProjectorLx
            }, {
              title: 'T_RESULT_FLOOR_TO_UPPER_HEIGHT',
              value: this.floor2upperProjectorLx
            }, {
              title: 'T_RESULT_SCREEN_TO_LENS_DISTANCE',
              value: this.pjYData + ' ' + this.unitLableText
            }, {
              title: 'T_RESULT_SCREEN_TO_PROJECTOR_DISTANCE',
              value: this.screen2projector
            }, {
              title: 'T_RESULTCEILING_TO_TOP_HEIGHT',
              value: this.screenTopToCeiling
            }, {
              title: 'T_RESULT_FLOOR_TO_BOTTOM',
              value: this.floor2bottomCpmuted
            }, {
              title: 'T_RESULT_WIDE_X_HEIGHT_SCREEN_SIZE',
              value: this.scrnW_H
            }, {
              title: 'T_RESULT_DIAGONAL_INCH_SCREEN_SIZE',
              value: this.screenSizeComputed
            })
          } else {
            this.projectorPosition.push({
              title: 'T_RESULT_CEILING_TO_BOTTOM_HEIGHT',
              value: this.ceiling2top
            }, {
              title: 'T_RESULT_SCREEN_TO_BOTTOM_HEIGHT',
              value: this.top2bottomProjector
            }, {
              title: 'T_RESULT_FLOOR_TO_UPPER_HEIGHT',
              value: this.floor2upperProjector
            }, {
              title: 'T_RESULT_SCREEN_TO_LENS_DISTANCE',
              value: this.pjYData + ' ' + this.unitLableText
            }, {
              title: 'T_RESULTCEILING_TO_TOP_HEIGHT',
              value: this.screenTopToCeiling
            }, {
              title: 'T_RESULT_FLOOR_TO_BOTTOM',
              value: this.floor2bottomCpmuted
            }, {
              title: 'T_RESULT_WIDE_X_HEIGHT_SCREEN_SIZE',
              value: this.scrnW_H
            }, {
              title: 'T_RESULT_DIAGONAL_INCH_SCREEN_SIZE',
              value: this.screenSizeComputed
            })

            if (this.selectedModelData.category === 4 && !this.isUSTWall) {
              const newItem = {
                title: 'T_RESULT_SCREEN_TO_FRONT_OF_PROJECTOR',
                value: this.screenToFrontOfProjector + ' ' + this.unitLableText
              }
              this.projectorPosition.splice(4, 0, newItem)
            }
          }
        }
        this.projectorSetting.push({
          title: 'T_RESULT_LENS_SHIFT_V',
          value: this.vLensShiftNowData
        })
        this.projectorSetting.push({
          title: 'T_RESULT_LENS_SHIFT_H',
          value: this.hLensShiftNowData
        })
        if (!this.isSimple) {
          if (!this.indAngleSwitch) {
            this.projectorSetting.push({
              title: 'T_RESULT_KEYSTONE_CORRECTION_V',
              value: this.$t(this.keyStoneVerticalShow)
            })
            this.projectorSetting.push({
              title: 'T_RESULT_KEYSTONE_CORRECTION_H',
              value: this.$t(this.keyStoneHorizontalShow)
            })
          } else {
            this.projectorSetting.push({
              title: 'T_RESULT_QUICKCORNER_CORRECTION',
              value: this.$t(this.cornerAreasShow)
            })
          }
        }
      } else {
        this.projectorPosition.push({
          title: 'T_SCREEN_SIZE_WH_COLON',
          value: this.scrnW_H,
          index: -1
        }, {
          title: 'T_SCREEN_SIZE_DIAGONAL_COLON',
          value: this.screenSizeComputed,
          index: -1
        }, {
          title: 'T_SCREEN_ANGLE_COLON',
          value: this.central_angle,
          index: -1
        }, {
          title: 'T_SCREEN_RADIUS_COLON',
          value: this.curveRadiu + ' ' + this.unitLableText,
          index: -1
        }, {
          title: 'T_SCREEN_ARC_COLON',
          value: this.curveArc + ' ' + this.unitLableText,
          index: -1
        }, {
          title: 'T_SCREEN_DEPTH_COLON',
          value: this.curve_depth + ' ' + this.unitLableText,
          index: -1
        })
        this.projectorSetting.push({
          title: 'T_RESULT_SCREEN_TO_LENS_DISTANCE',
          value: this.pjYData + ' ' + this.unitLableText,
          index: -1
        }, {
          title: 'T_PROJECTOR_ANGLE_V_COLON',
          value: this.vAngleData,
          index: -1
        }, {
          title: 'T_PROJECTOR_ANGLE_R_COLON',
          value: this.hAngleData,
          index: -1
        }, {
          title: 'T_LENSSHIFT_V_COLON',
          value: this.vLensShiftNowData,
          index: -1
        }, {
          title: 'T_LENSSHIFT_H_COLON',
          value: this.hLensShiftNowData,
          index: -1
        })
      }

      /* this.projectorSetting.push({
        title: 'T_CURVED_SURFACE_CORRECTION',
        value: ''
      }) */
    },

    initReport () {
      this.$refs.resultReport.initCanvas()
      if (document.getElementById('USTview-copy')) {
        document.getElementById('USTview-copy').appendChild(this.UstResultImg)
      }
      if (document.getElementById('Simpleview-copy')) {
        document.getElementById('Simpleview-copy').appendChild(this.SimpleResultImg)
      }
    },

    getRelativeBasePointer (value) {
      this.$nextTick(() => {
        let screenPointer0 = this.drawData[0][0] || {}
        return 'X: ' + this.$commonJs.changeUnit(value.pjX - screenPointer0.x, this.graph.unit) + this.unitLableText + ', Y: ' + this.$commonJs.changeUnit(value.pjY, this.graph.unit) + this.unitLableText + ', Z: ' + this.$commonJs.changeUnit(value.pjZ - screenPointer0.z, this.graph.unit) + this.unitLableText
      })
    }
  },

  mounted () {
    this.relativeBasePointer = this.getRelativeBasePointer(this.graph)
    // GA追加Start
    EventBus.$on('saveSettingsClick', () => {
      EventBus.$emit('sendToGA', 'add_to_wishlist')
    })
    // GA追加End
  },

  // GA追加Start
  beforeDestroy () {
    EventBus.$off('saveSettingsClick')
  },
  // GA追加End

  components: {
    resultReport
  },

  filters: {
    filterKeyStone (value) {
      return value === 1 ? 'Available' : 'Not Available'
    }
  },

  computed: {
    ...mapState([
      'graph',
      'vLensShift',
      'hLensShift',
      'vAngleFlag',
      'vAngle',
      'hAngleFlag',
      'hAngle',
      'selectedModelData',
      'selectedLensData',
      'drawData',
      'houseInfo',
      'vLensShiftNow',
      'hLensShiftNow',
      'floor2bottom',
      'screenSize',
      'position',
      'isUSTWall',
      'dashFlag',
      'isSimple',
      'browserType',
      'SettingActive',
      'setfontSize',
      'screenActive',
      'throwDisActive',
      'indAngleSwitch',
      'isOnCornerAreas',
      'ustLensToFrontPj',
      'searchTabActive',
      'curveDepth',
      'curveCentralAngle',
      'curveRadius',
      'curveShape',
      'curveChordLength',
      'curveScreenHeight'
    ]),

    ...mapGetters([
      'unitLabel'
    ]),

    unitLableText () {
      if (this.graph.unit === 'T_FEET_FRACTION' || this.graph.unit === 'T_INCH_FRACTION') {
        return ''
      } else {
        return this.unitLabel
      }
    },

    pjYData () {
      return this.$commonJs.changeUnit(this.graph.pjY, this.graph.unit)
    },

    screenToFrontOfProjector () {
      return this.$commonJs.changeUnit(this.graph.pjY - this.ustLensToFrontPj, this.graph.unit)
    },

    scrnW_H () {
      if (this.isCurvedTab) {
        let width = this.curveShape === '0' ? this.curveScreenHeight : this.curveChordLength
        let height = this.curveShape === '0' ? this.curveChordLength : this.curveScreenHeight
        let scrnW = this.$commonJs.changeUnit(width, this.graph.unit)
        let scrnH = this.$commonJs.changeUnit(height, this.graph.unit)
        return scrnW + ' x ' + scrnH + ' ' + this.unitLableText
      } else {
        let scrnW = this.$commonJs.changeUnit(this.graph.scrnW, this.graph.unit)
        let scrnH = this.$commonJs.changeUnit(this.graph.scrnH, this.graph.unit)
        if ((this.vAngleFlag && this.vAngle !== 0) || (this.hAngleFlag && this.hAngle !== 0)) {
          if (this.dashFlag) {
            return scrnW + ' x ' + scrnH + ' ' + this.unitLableText
          } else {
            return '-'
          }
        } else {
          return scrnW + ' x ' + scrnH + ' ' + this.unitLableText
        }
      }
    },

    floor2Projector () {
      let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
      if (this.position === 0) {
        return this.$commonJs.changeUnit(f2l, this.graph.unit)
      } else {
        return this.$commonJs.changeUnit(this.houseInfo.roomH - f2l, this.graph.unit)
      }
    },
    keyStoneVertical () {
      let data = this.vAngleFlag ? this.hAngleFlag ? 0 : this.vAngle >= this.keyStoneRangleV.min && this.vAngle <= this.keyStoneRangleV.max ? 1 : 0 : 1
      this.SET_KEYSTONEVERTICAL(data)
      return data
    },

    keyStoneVerticalShow () {
      return this.keyStoneVertical === 1 ? 'T_RESULT_CAN_BE_CORRECTED' : 'T_RESULT_EXCEEDED_KEYSTONE_CORRECTION'
    },

    keyStoneHorizontal () {
      let data = this.hAngleFlag ? this.vAngleFlag ? 0 : this.hAngle >= this.keyStoneRangleH.min && this.hAngle <= this.keyStoneRangleH.max ? 1 : 0 : 1
      this.SET_KEYSTONEHORIZONTAL(data)
      return data
    },

    keyStoneHorizontalShow () {
      return this.keyStoneHorizontal === 1 ? 'T_RESULT_CAN_BE_CORRECTED' : 'T_RESULT_EXCEEDED_KEYSTONE_CORRECTION'
    },

    cornerAreasShow () {
      return this.isOnCornerAreas ? 'T_RESULT_CAN_BE_CORRECTED' : 'T_RESULT_EXCEEDED_QUICKCORNER_CORRECTION'
    },

    keyStoneRangleV () {
      let data = this.selectedModelData
      return {'min': data.keystoneVMin, 'max': data.keystoneVMax}
    },

    keyStoneRangleH () {
      let data = this.selectedModelData
      return {'min': data.keystoneHMin, 'max': data.keystoneHMax}
    },

    vAngleData () {
      return (this.vAngleFlag ? this.vAngle : 0) + '°'
    },

    hAngleData () {
      return (this.hAngleFlag ? this.hAngle : 0) + '°'
    },

    floor2topCpmuted () {
      if (this.drawData) {
        let textName2 = this.drawData[0][3].z - this.drawData[0][0].z
        let f2top = this.houseInfo.roomH - (this.graph.scrnH + this.floor2bottom) + (this.graph.scrnH - textName2)
        return this.$commonJs.changeUnit(f2top > 0 ? f2top : 0, this.graph.unit) + ' ' + this.unitLableText
      }
      return null
    },

    screenTopToCeiling () {
      const value = this.drawData[0][0].z
      return this.$commonJs.changeUnit(value, this.graph.unit) + ' ' + this.unitLableText
    },

    screen2projector () {
      let BrightnessDataLx = this.getBrightnessLx
      if (this.selectedModelData.lensExchange === true) {
        let s2projector = this.graph.pjY - BrightnessDataLx
        return this.$commonJs.changeUnit(s2projector, this.graph.unit) + ' ' + this.unitLableText
      } else {
        let s2projector = this.graph.pjY - this.selectedLensData.lx
        return this.$commonJs.changeUnit(s2projector, this.graph.unit) + ' ' + this.unitLableText
      }
    },

    floor2upperProjector () {
      let BrightnessDataUp = this.getBrightnessUp
      let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
      if (this.selectedModelData.lensExchange === true) {
        let f2upper = f2l - BrightnessDataUp
        return this.$commonJs.changeUnit(f2upper > 0 ? f2upper : 0, this.graph.unit) + ' ' + this.unitLableText
      } else {
        let f2upper = f2l - this.selectedLensData.up
        return this.$commonJs.changeUnit(f2upper > 0 ? f2upper : 0, this.graph.unit) + ' ' + this.unitLableText
      }
    },

    floor2upperProjectorLx () {
      let BrightnessDataUp = this.getBrightnessUp
      let BrightnessDataCc = this.getBrightnessCc
      let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
      if (this.selectedModelData.lensExchange === true) {
        let f2upperlx = f2l + BrightnessDataCc - BrightnessDataUp
        return this.$commonJs.changeUnit(f2upperlx, this.graph.unit) + ' ' + this.unitLableText
      } else {
        let f2upperlx = f2l + BrightnessDataCc - this.selectedLensData.up
        return this.$commonJs.changeUnit(f2upperlx, this.graph.unit) + ' ' + this.unitLableText
      }
    },

    ceiling2top () {
      let BrightnessDataMu = this.getBrightnessMu
      let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
      if (this.selectedModelData.lensExchange === true) {
        let c2top = this.houseInfo.roomH - (f2l + BrightnessDataMu)
        return this.$commonJs.changeUnit(c2top > 0 ? c2top : 0, this.graph.unit) + ' ' + this.unitLableText
      } else {
        let c2top = this.houseInfo.roomH - (f2l + this.selectedLensData.mu)
        return this.$commonJs.changeUnit(c2top > 0 ? c2top : 0, this.graph.unit) + ' ' + this.unitLableText
      }
    },

    ceiling2topLx () {
      let BrightnessDataCc = this.getBrightnessCc
      let BrightnessDataMu = this.getBrightnessMu
      let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
      if (this.selectedModelData.lensExchange === true) {
        let c2toplx = this.houseInfo.roomH - (f2l + BrightnessDataCc + BrightnessDataMu)
        return this.$commonJs.changeUnit(c2toplx > 0 ? c2toplx : 0, this.graph.unit) + ' ' + this.unitLableText
      } else {
        let c2toplx = this.houseInfo.roomH - (f2l + BrightnessDataCc + this.selectedLensData.mu)
        return this.$commonJs.changeUnit(c2toplx > 0 ? c2toplx : 0, this.graph.unit) + ' ' + this.unitLableText
      }
    },

    floor2footProjector () {
      let BrightnessDataFe = this.getBrightnessFe
      let f2l = this.houseInfo.roomH - this.graph.pjZ
      let f2foot = f2l - this.selectedLensData.fe
      if (this.selectedModelData.lensExchange === true) {
        f2foot = f2l - BrightnessDataFe
      }
      this.floor2footProjectorIsNegativeNum = (f2foot * 10).toFixed(0) < 0
      return this.$commonJs.changeUnit(f2foot, this.graph.unit) + ' ' + this.unitLableText
    },

    screenBottom2footProjector () {
      let heightV = this.curveShape === '0' ? this.curveChordLength : this.curveScreenHeight
      let screenBottom = (this.houseInfo.roomH + heightV) / 2
      let brightnessDataFe = this.selectedModelData.lensExchange === true ? this.getBrightnessFe : this.selectedLensData.fe
      let sb2foot = screenBottom - (this.graph.pjZ + brightnessDataFe)
      return this.$commonJs.changeUnit(sb2foot, this.graph.unit) + ' ' + this.unitLableText
    },

    getBrightnessFe () {
      let brightnessfe
      let lensExchange = this.selectedModelData.lensExchange
      if (lensExchange) {
        let code = this.selectedModelData.code
        let lensId = this.selectedLensData.id
        for (let i = 0; i < this.Brightness.optionLens.length; i++) {
          if (this.Brightness.optionLens[i].code === code && this.Brightness.optionLens[i].lensId === lensId) {
            brightnessfe = this.Brightness.optionLens[i].fe / 10
          }
        }
      }
      return brightnessfe
    },

    getBrightnessCc () {
      let brightnesscc
      let lensExchange = this.selectedModelData.lensExchange
      if (lensExchange) {
        let code = this.selectedModelData.code
        let lensId = this.selectedLensData.id
        for (let i = 0; i < this.Brightness.optionLens.length; i++) {
          if (this.Brightness.optionLens[i].code === code && this.Brightness.optionLens[i].lensId === lensId) {
            brightnesscc = this.Brightness.optionLens[i].cc / 10
          }
        }
      }
      return brightnesscc
    },

    getBrightnessMu () {
      let brightnessmu
      let lensExchange = this.selectedModelData.lensExchange
      if (lensExchange) {
        let code = this.selectedModelData.code
        let lensId = this.selectedLensData.id
        for (let i = 0; i < this.Brightness.optionLens.length; i++) {
          if (this.Brightness.optionLens[i].code === code && this.Brightness.optionLens[i].lensId === lensId) {
            brightnessmu = this.Brightness.optionLens[i].mu / 10
          }
        }
      }
      return brightnessmu
    },

    getBrightnessUp () {
      let brightnessup
      let lensExchange = this.selectedModelData.lensExchange
      if (lensExchange) {
        let code = this.selectedModelData.code
        let lensId = this.selectedLensData.id
        for (let i = 0; i < this.Brightness.optionLens.length; i++) {
          if (this.Brightness.optionLens[i].code === code && this.Brightness.optionLens[i].lensId === lensId) {
            brightnessup = this.Brightness.optionLens[i].up / 10
          }
        }
      }
      return brightnessup
    },

    getBrightnessLx () {
      let brightnesslx
      let lensExchange = this.selectedModelData.lensExchange
      if (lensExchange) {
        let code = this.selectedModelData.code
        let lensId = this.selectedLensData.id
        for (let i = 0; i < this.Brightness.optionLens.length; i++) {
          if (this.Brightness.optionLens[i].code === code && this.Brightness.optionLens[i].lensId === lensId) {
            brightnesslx = this.Brightness.optionLens[i].lx / 10
          }
        }
      }
      return brightnesslx
    },

    top2bottomProjector () {
      let BrightnessDataMu = this.getBrightnessMu
      let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
      if (this.selectedModelData.lensExchange === true) {
        let top2projector = Math.abs((f2l + BrightnessDataMu) - (this.graph.scrnH + this.floor2bottom))
        return this.$commonJs.changeUnit(top2projector, this.graph.unit) + ' ' + this.unitLableText
      } else {
        let top2projector = Math.abs((f2l + this.selectedLensData.mu) - (this.graph.scrnH + this.floor2bottom))
        return this.$commonJs.changeUnit(top2projector, this.graph.unit) + ' ' + this.unitLableText
      }
    },

    top2bottomProjectorLx () {
      let BrightnessDataMu = this.getBrightnessMu
      let BrightnessDataCc = this.getBrightnessCc
      let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
      if (this.selectedModelData.lensExchange === true) {
        let top2projectorlx = Math.abs((f2l + BrightnessDataCc + BrightnessDataMu) - (this.graph.scrnH + this.floor2bottom))
        return this.$commonJs.changeUnit(top2projectorlx, this.graph.unit) + ' ' + this.unitLableText
      } else {
        let top2projectorlx = Math.abs((f2l + BrightnessDataCc + this.selectedLensData.mu) - (this.graph.scrnH + this.floor2bottom))
        return this.$commonJs.changeUnit(top2projectorlx, this.graph.unit) + ' ' + this.unitLableText
      }
    },

    bottom2FootProjector () {
      let BrightnessDataFe = this.getBrightnessFe
      let f2l = this.houseInfo.roomH - this.graph.pjZ < 0 ? 0 : this.houseInfo.roomH - this.graph.pjZ
      if (this.selectedModelData.lensExchange === true) {
        let b2footprojector = Math.abs((f2l - BrightnessDataFe) - this.floor2bottom)
        return this.$commonJs.changeUnit(b2footprojector, this.graph.unit) + ' ' + this.unitLableText
      } else {
        let b2footprojector = Math.abs((f2l - this.selectedLensData.fe) - this.floor2bottom)
        return this.$commonJs.changeUnit(b2footprojector, this.graph.unit) + ' ' + this.unitLableText
      }
    },

    floor2bottomCpmuted () {
      return this.$commonJs.changeUnit(this.floor2bottom, this.graph.unit) + ' ' + this.unitLableText
    },

    screenSizeComputed () {
      if (this.isCurvedTab) {
        let width = this.curveShape === '0' ? this.curveScreenHeight : this.curveChordLength
        let height = this.curveShape === '0' ? this.curveChordLength : this.curveScreenHeight
        let screenSize = Math.sqrt(width * width + height * height)
        return this.$commonJs.changeUnit(screenSize, 'T_INCH_DECIMAL') + ' inch'
      } else {
        if ((this.vAngleFlag && this.vAngle !== 0) || (this.hAngleFlag && this.hAngle !== 0)) {
          if (this.dashFlag) {
            return (this.screenSize * 1).toFixed(2) + ' inch'
          } else {
            return '-'
          }
        } else {
          return (this.screenSize * 1).toFixed(2) + ' inch'
        }
      }
    },

    vLensShiftNowData () {
      return this.graph.vLensShift.max === this.graph.vLensShift.min ? 'N/A' : this.vLensShiftNow.toFixed(0) + '%'
    },

    hLensShiftNowData () {
      return this.graph.hLensShift.max === this.graph.hLensShift.min ? 'N/A' : this.hLensShiftNow.toFixed(0) + '%'
    },
    isEdge () {
      let userAgent = navigator.userAgent
      let isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1
      let isEdge = userAgent.indexOf('Edge') > -1 && !isIE

      return isEdge
    },
    isCurvedTab () {
      return this.searchTabActive === 'CurvedSurface'
    },
    curveArc () {
      return this.$commonJs.changeUnit(this.curveRadius * this.curveCentralAngle, this.graph.unit)
    },
    central_angle () {
      return (180 * this.curveCentralAngle / Math.PI).toFixed(1) + '°'
    },
    curve_depth () {
      return this.$commonJs.changeUnit(this.curveDepth, this.graph.unit)
    },
    curveRadiu () {
      return this.$commonJs.changeUnit(this.curveRadius, this.graph.unit)
    }
  },

  watch: {
    graph: {
      handler (newValue, oldValue) {
        this.relativeBasePointer = ''
        this.relativeBasePointer = this.getRelativeBasePointer(newValue)
      },
      deep: true
    },
    dialogVisible (val) {
      if (!val && this.isUSTWall) {
        if (document.getElementById('ustImg')) {
          let $ustImg = document.getElementById('ustImg')
          if (this.browserType === 'other' || this.isEdge) {
            $ustImg.remove()
          } else {
            $ustImg.removeNode(true)
          }
        }
      }
      if (!val && this.isSimple) {
        if (document.getElementById('simpleImg')) {
          let $simpleImg = document.getElementById('simpleImg')
          if (this.browserType === 'other' || this.isEdge) {
            $simpleImg.remove()
          } else {
            $simpleImg.removeNode(true)
          }
        }
      }
    }
  }
}
</script>

<style scoped>
.result-infomation {
  width: 810px;
  height: 361px;
  margin-top:10px;
  border: 2px solid #bdbdbd;
  background: #fff;
}

.projector_text span {
  line-height: 30px;
  font-size: 14px;
  font-weight: bold;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.result-information-button {
  position: absolute;
  bottom: 5px;
  left: 10px;
}
.widthLimit {
  width: 96%;
  line-height: 30px;
  bottom: 18px;
}
.copy,
.pdf {
  padding-left: 6px;
  padding-right: 6px;
  /* min-width: 200px; */
  margin-top: 30px;
}
.pdf {
  float: right;
  margin-left: 15px;
}
.pdfBtnDiv{
  float: right;
}
.pdfBtn{
  /* min-width: 200px; */
  margin-top: 30px;
}
.pdfBtnM_S{
  margin-left: 5px;
}
.pdfBtnM_Q{
  margin-left: 5px;
}
.padding-left-18 {
  padding-left: 18px;
}

.projector_setting li{
  list-style: disc;
  margin-left: 21px;
}

.projector_setting li:first-child{
  list-style: none;
  margin-left: 0;
}

.information-right img {
  width: 100%;
  height: auto;
}

.special_width {
  width: auto;
}

.simple-pdf-title {
  float: right;
}
</style>



// WEBPACK FOOTER //
// src/view/result/resultInformationButton.vue